import { PressEvent } from "react-aria-components";
import { Button } from "../Common/Buttons/Button";

interface ShareCustomObjectButtonProps {
  onPress: (_: PressEvent) => void;
}
export const ShareCustomObjectButton = ({
  onPress,
}: ShareCustomObjectButtonProps) => (
  <Button
    onPress={onPress}
    size="small"
    variant="outlineInverted"
    iconStart="mail"
    title="Share public profile"
  />
);
